<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn
                :color="color + ' darken-1'"
                dark
                fab
                small
                v-bind="$attrs"
                v-on="{...on,...$listeners}"
            >
                <v-icon>mdi-source-branch-refresh</v-icon>
            </v-btn>
        </template>
        <span>Relayout graph</span>
    </v-tooltip>
</template>

<script>

export default {
    name: "RelayoutButton",
    props: {
        color: {
            type: String,
            requred: true
        }
    }
}
</script>
